// @flow

import zentakeApi from 'api'
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import React from 'react'

function useVisited() {
  const { mode } = React.useContext(ResourceSharedContext) || {}

  const { response } = React.useContext(ResourceResponseContext) || {}

  const updateHasVisited = React.useCallback(() => {
    if (mode === 'client' && response?.id) {
      zentakeApi.updateResponseVisited(response?.id, { hasVisited: true })
    }
  }, [mode, response?.id])

  React.useEffect(() => {
    if (mode !== 'client') return

    updateHasVisited()
  }, [mode, updateHasVisited])
}

export default useVisited
